import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Checklist from '../../../../components/checklist'
import { Column, Row } from '../../../../components/layout-row'
import Textblock from '../../../../components/textblock'

import styles from './features.module.scss'
import imgDashboard from './fakturering_offerter_pinne.png'
import imgReceiver from './web-invoice.png'
import imgUser from './billing-form.png'
import imgTallying from './billing-tallying.png'
import imgRotRut from './billing-rot-rut.png'
import DoodleBackground from '../../../../components/doodle-background'

const Features = () => (
  <div className={styles.root}>
    <DoodleBackground className={styles.doodleBackground} variant="topRight" />
    <Row id="feature-one" top="first">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Skapa offerter och fakturor med några klick. Hur många du vill, när du vill – helt gratis. Offerter godkänns snabbt och smidigt med BankID - tryggt, både för dig och din kund."
              id="billing.features.user-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage
                  defaultMessage="Obegränsat antal fakturor och offerter"
                  id="billing.features.user-own-logo"
                  key="1"
                />,
                <FormattedMessage
                  defaultMessage="Obegränsat antal användare"
                  id="billing.features.user-editable"
                  key="2"
                />,
                <FormattedMessage
                  defaultMessage="Fakturera från offert med ett klick"
                  id="billing.features.platforms"
                  key="3"
                />,
                <FormattedMessage
                  defaultMessage="Lägg enkelt till bilagor"
                  id="billing.features.tallying-and-reminders"
                  key="4"
                />,
                <FormattedMessage
                  defaultMessage="Automatisk avprickning och påminnelse"
                  id="billing.features.5"
                  key="5"
                />,
              ]}
              variant="free"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Smidigt för dig" id="billing.features.user-subtitle" />}
          title={<FormattedMessage defaultMessage="Utan onödiga begränsningar" id="billing.features.user-title" />}
          variant="free"
        />
      </Column>

      <Column>
        <img alt="Dooer billing dashboard" src={imgDashboard} />
      </Column>
    </Row>

    <Row id="feature-two">
      <Column first>
        <img alt="Dooer web invoice" src={imgReceiver} style={{ paddingLeft: '20px' }} />
      </Column>

      <Column limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Dooers webbfaktura är en unik sida på webben, en betallänk som din kund når var den än är. Du väljer själv att skicka fakturan som en PDF, webbfaktura eller via ett SMS och din kund väljer det betalsätt som passar dem bäst. Till exempel med kort, Swish eller Apple pay."
              id="billing.features.receiver-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage
                  defaultMessage="Kortbetalning, Apple Pay och Google Pay via Stripe"
                  id="billing.features.payment-methods"
                  key="1"
                />,
                <FormattedMessage
                  defaultMessage="Bankgiro och Plusgiro"
                  id="billing.features.bankgiro-and-plusgiro"
                  key="2"
                />,
                <FormattedMessage defaultMessage="Swish" id="billing.features.swish" key="3" />,
                <FormattedMessage
                  defaultMessage="Utlandsbetalning med IBAN och BIC"
                  id="billing.features.international"
                  key="3"
                />,
              ]}
              variant="free"
            />
          }
          subTitle={
            <FormattedMessage defaultMessage="Webbfaktura med betallänk" id="billing.features.receiver-subtitle" />
          }
          title={<FormattedMessage defaultMessage="Få betalt snabbare" id="billing.features.receiver-title" />}
          variant="free"
        />
      </Column>
    </Row>

    <Row id="feature-three">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Vi på Dooer tänkte, måste ROT- och RUT-administration verkligen vara omständig? Vi tittade på alla delar från utställande av faktura till begäran av utbetalning från Skatteverket och tänkte om. Nu kan du fakturera med ROT och RUT och begära utbetalning från Skatteverket med ett klick. Dooer skapar allt underlag till Skatteverket, du behöver bara signera med BankID. Smidigt!"
              id="billing.features.rot-rut-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage
                  defaultMessage="Stöd för avdrag för flera personer på samma faktura"
                  id="billing.features.rot-rut-multiple-person-support"
                  key="1"
                />,
                <FormattedMessage
                  defaultMessage="Begär utbetalning från Skatteverket med ett klick"
                  id="billing.features.rot-rut-request-payment"
                  key="2"
                />,
                <FormattedMessage
                  defaultMessage="Automatisk beräkning av ROT- och RUT-avdrag"
                  id="billing.features.rot-rut-automatic-calculation"
                  key="3"
                />,
              ]}
              variant="free"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Ett helt nytt tänk" id="billing.features.rot-rut-subtitle" />}
          title={<FormattedMessage defaultMessage="ROT & RUT på bara ett klick" id="billing.features.rot-rut-title" />}
          variant="free"
        />
      </Column>
      <Column>
        <img alt="Dooer automatic tallying" src={imgRotRut} style={{ paddingLeft: '20px' }} />
      </Column>
    </Row>

    <Row id="feature-four">
      <Column first>
        <img alt="Dooer automatic tallying" src={imgTallying} style={{ paddingLeft: '20px' }} />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Med Dooers fakturering kan du få betalningar registrerade automatiskt med våra smarta kopplingar till banker och betalningsleverantörer. Det ger dig full kontroll över alla dina fakturor och betalningar i realtid. Supersmidigt."
              id="billing.features.tallying-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage
                  defaultMessage="Trygg banksynk"
                  id="billing.features.tallying-safe-banksync"
                  key="1"
                />,
                <FormattedMessage defaultMessage="Stripe-integration" id="billing.features.tallying-stripe" key="2" />,
                <FormattedMessage
                  defaultMessage="Funkar med SEB, Swedbank, Handelsbanken och Nordea"
                  id="billing.features.tallying-banks"
                  key="3"
                />,
                <FormattedMessage
                  defaultMessage="Spara tid och få ökad kontroll"
                  id="billing.features.tallying-save-time-and-gain-control"
                  key="4"
                />,
              ]}
              variant="free"
            />
          }
          subTitle={
            <FormattedMessage defaultMessage="Slipp onödig administration" id="billing.features.tallying-subtitle" />
          }
          title={
            <FormattedMessage
              defaultMessage="Automatisk registrering av betalningar"
              id="billing.features.tallying-title"
            />
          }
          variant="free"
        />
      </Column>
    </Row>

    <Row id="feature-five">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="När du börjar använda Dooer verifierar du dig säkert och tryggt med BankID så ingen obehörig får tillgång till ditt Dooer-konto. Du skapar fakturor som uppfyller Skatteverkets krav och SIS-standard. Allt ligger i molnet så du har tillgång till din fakturering överallt och ingen installation krävs, plus att allt är sökbart."
              id="billing.features.sec-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage defaultMessage="Verifiering med BankID" id="billing.features.billing-pros" key="1" />,
                <FormattedMessage defaultMessage="Molnbaserad tjänst" id="billing.features.billing-bankID" key="2" />,
                <FormattedMessage defaultMessage="Automatisk backup" id="billing.features.billing-cloud" key="3" />,
                <FormattedMessage defaultMessage="Full historik" id="billing.features.billing-backups" key="4" />,
              ]}
              variant="free"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Säkert och tillgängligt" id="billing.features.sec-subtitle" />}
          title={<FormattedMessage defaultMessage="Både tryggt och snyggt" id="billing.features.sec-title" />}
          variant="free"
        />
      </Column>
      <Column>
        <img alt="Dooer free billing" src={imgUser} />
      </Column>
    </Row>
  </div>
)

export default Features
